import React, { useState } from "react";
import IncidentDetailsPopup from "./IncidentDetailsPopup";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faDownload,
  faEdit,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import ApproveModal from "../ApproveModal";
import { API, get } from "../../../config";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import EscalatedModal from "../CDD/EscalatedModal";
// import { Button } from "../../../components/ui/button";
import { LucideMessageSquareShare } from "lucide-react";

const IncidentActionButton = ({
  id,
  setEdit,
  setIncidentId,
  toggleShowAddEditIncident,
  trustId,
  incident,
  approved,
  approvalPremission,
  fetchIncidents,
  setLoading,
}) => {
  const [showView, setShowView] = useState(false);
  const [confirmEscalated, setConfirmEscalated] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const [showApprove, setShowApprove] = useState(false);

  const toggleApproveModal = () => {
    setShowApprove(!showApprove);
  };

  const toggleConfirmEscalated = () => {
    setConfirmEscalated(!confirmEscalated);
  };
  const handleDownload = async (id) => {
    try {
      setLoading(true);
      const { data } = await get(`${API.INCIDENT_DOWNLOAD}/${id}`);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("target", "_blank");
        a.setAttribute("download", file[file.length - 1] || "receipts.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        {!approved ? (
          <>
            <span>/</span>
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    setEdit(true);
                    toggleShowAddEditIncident();
                    setIncidentId(id);
                  }}
                />
              </span>
            </CustomTooltip>
            <span>/</span>
            <CustomTooltip message={"Escalate"}>
              {/* <Button
                onClick={() => {
                  toggleConfirmEscalated();
                }}
              >
                <div className="flex items-center gap-1"> */}
              <LucideMessageSquareShare
                size={18}
                onClick={() => {
                  toggleConfirmEscalated();
                }}
              />
              {/* <span>Escalate</span>
                </div>
              </Button> */}
            </CustomTooltip>
            {approvalPremission ? (
              <>
                <span>/</span>
                <CustomTooltip message={"Approve"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      size="1x"
                      onClick={() => {
                        toggleApproveModal();
                      }}
                    />
                  </span>
                </CustomTooltip>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <>
            <span>/</span>
            <CustomTooltip message={"Download"}>
              <span>
                <FontAwesomeIcon
                  icon={faDownload}
                  size="1x"
                  onClick={() => {
                    handleDownload(id);
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>

      {showView && (
        <IncidentDetailsPopup
          showView={showView}
          incidentId={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
          trustId={trustId}
          incident={incident}
        />
      )}
      {showApprove && (
        <ApproveModal
          showApprove={showApprove}
          id={id}
          type={"incident"}
          toggleApproveModal={toggleApproveModal}
          setShowApprove={setShowApprove}
          trustId={trustId}
          fetchData={fetchIncidents}
          setLoading={setLoading}
        />
      )}

      {confirmEscalated && (
        <ResponsiveDrawerForm
          description={""}
          title={`Escalated`}
          handleOpen={() => {}}
          handleClose={() => {
            toggleConfirmEscalated();
          }}
          popupType={"cdds"}
          write={true}
          buttonText={""}
          open={confirmEscalated}
          buttonClassName={""}
          setOpen={setConfirmEscalated}
          className={"sm:max-w-3xl"}
        >
          <EscalatedModal
            data={incident}
            toggleConfirmEscalated={toggleConfirmEscalated}
            fetchData={fetchIncidents}
          />
        </ResponsiveDrawerForm>
      )}
    </>
  );
};

export default IncidentActionButton;
